import React from "react";
import { useHistory } from "react-router-dom";
import logout from "./logout";
import AuthContext from "../components/auth-context";

const TabBar = ({
  showType,
  item1,
  item1Route,
  item2,
  item2Route,
  pageName,
}) => {
  let history = useHistory();
  const Auth = React.useContext(AuthContext);

  return (
    <div className="container-fluid" id="container-fluidx">
      <ul
        className="nav nav-tabs md-tabs tabs-red "
        id="myTabMD"
        role="tablist"
      >
        <li>
          <a
            className="nav-link"
            id="dropdown"
            data-toggle="dropdown"
            role="tab"
            aria-controls="all-md"
            aria-selected="false"
            href="#0"
          >
            Menü
          </a>
          <ul className="dropdown-menu" style={{ top: -10, position: "fixed" }}>
            <li>
              <a
                style={{ fontSize: 15 }}
                onClick={() => history.push(item1Route)}
              >
                {item1}
              </a>
            </li>
            <li>
              <a
                style={{ fontSize: 15 }}
                onClick={() => history.push(item2Route)}
              >
                {item2}
              </a>
            </li>
            <li>
              <a style={{ fontSize: 15 }} onClick={() => logout({ Auth })}>
                Çıkış Yap
              </a>
            </li>
          </ul>
        </li>
        <li className="nav-item">
          <a
            className="nav-link"
            style={{ fontSize: 16, fontWeight: 600, color: "#ffd10d" }}
            href={`/${pageName}`}
          >
            SambaPOS Getir
          </a>
        </li>
        {pageName === "order" && (
          <>
            <li className="nav-item">
              <a
                className={`nav-link ${showType === 0 && "active"}`}
                id="newOrders-tab-md tab-0"
                data-toggle="tab"
                href="#newOrders-md"
                role="tab"
                data-id="0"
                aria-controls="newOrders-md"
                aria-selected={showType === 0 && "true"}
              >
                Yeni Siparişler
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                id="approved-tab-md tab-1"
                data-toggle="tab"
                href="#approved-md"
                role="tab"
                data-id="1"
                aria-controls="approved-md"
              >
                Onaylanan Siparişler
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                id="denied-tab-md tab-2"
                data-toggle="tab"
                href="#denied-md"
                role="tab"
                data-id="2"
                aria-controls="denied-md"
                aria-selected="true"
              >
                Reddedilen Siparişler
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                id="all-tab-md tab-3"
                data-toggle="tab"
                href="#all-md"
                role="tab"
                aria-controls="all-md"
                data-id="3"
                aria-selected="true"
              >
                Tüm Siparişler
              </a>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default TabBar;
